// source: drinks.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var user_pb = require('./user_pb.js');
goog.object.extend(proto, user_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.saufdings.ActiveEventResponse', null, global);
goog.exportSymbol('proto.saufdings.CreateEventRequest', null, global);
goog.exportSymbol('proto.saufdings.Drink', null, global);
goog.exportSymbol('proto.saufdings.DrinkActiviteList', null, global);
goog.exportSymbol('proto.saufdings.DrinkActivity', null, global);
goog.exportSymbol('proto.saufdings.Drinklist', null, global);
goog.exportSymbol('proto.saufdings.Event', null, global);
goog.exportSymbol('proto.saufdings.EventLeaderboardEntry', null, global);
goog.exportSymbol('proto.saufdings.EventLeaderboardRequest', null, global);
goog.exportSymbol('proto.saufdings.EventLeaderboardResponse', null, global);
goog.exportSymbol('proto.saufdings.EventList', null, global);
goog.exportSymbol('proto.saufdings.EventMembershipRequest', null, global);
goog.exportSymbol('proto.saufdings.EventVisibility', null, global);
goog.exportSymbol('proto.saufdings.ListEventsRequest', null, global);
goog.exportSymbol('proto.saufdings.UpdateEventAccessRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.Drinklist = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.Drinklist.repeatedFields_, null);
};
goog.inherits(proto.saufdings.Drinklist, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.Drinklist.displayName = 'proto.saufdings.Drinklist';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.DrinkActiviteList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.DrinkActiviteList.repeatedFields_, null);
};
goog.inherits(proto.saufdings.DrinkActiviteList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.DrinkActiviteList.displayName = 'proto.saufdings.DrinkActiviteList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.EventList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.EventList.repeatedFields_, null);
};
goog.inherits(proto.saufdings.EventList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.EventList.displayName = 'proto.saufdings.EventList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.Event.displayName = 'proto.saufdings.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.ListEventsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.ListEventsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.ListEventsRequest.displayName = 'proto.saufdings.ListEventsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.CreateEventRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.CreateEventRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.CreateEventRequest.displayName = 'proto.saufdings.CreateEventRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.EventMembershipRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.EventMembershipRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.EventMembershipRequest.displayName = 'proto.saufdings.EventMembershipRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.ActiveEventResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.ActiveEventResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.ActiveEventResponse.displayName = 'proto.saufdings.ActiveEventResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.EventLeaderboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.EventLeaderboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.EventLeaderboardRequest.displayName = 'proto.saufdings.EventLeaderboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.EventLeaderboardEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.EventLeaderboardEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.EventLeaderboardEntry.displayName = 'proto.saufdings.EventLeaderboardEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.EventLeaderboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.EventLeaderboardResponse.repeatedFields_, null);
};
goog.inherits(proto.saufdings.EventLeaderboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.EventLeaderboardResponse.displayName = 'proto.saufdings.EventLeaderboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.UpdateEventAccessRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.UpdateEventAccessRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.UpdateEventAccessRequest.displayName = 'proto.saufdings.UpdateEventAccessRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.Drink = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.Drink, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.Drink.displayName = 'proto.saufdings.Drink';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.DrinkActivity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.DrinkActivity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.DrinkActivity.displayName = 'proto.saufdings.DrinkActivity';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.Drinklist.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.Drinklist.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.Drinklist.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.Drinklist} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Drinklist.toObject = function(includeInstance, msg) {
  var f, obj = {
drinksList: jspb.Message.toObjectList(msg.getDrinksList(),
    proto.saufdings.Drink.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.Drinklist}
 */
proto.saufdings.Drinklist.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.Drinklist;
  return proto.saufdings.Drinklist.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.Drinklist} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.Drinklist}
 */
proto.saufdings.Drinklist.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.Drink;
      reader.readMessage(value,proto.saufdings.Drink.deserializeBinaryFromReader);
      msg.addDrinks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.Drinklist.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.Drinklist.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.Drinklist} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Drinklist.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saufdings.Drink.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Drink drinks = 1;
 * @return {!Array<!proto.saufdings.Drink>}
 */
proto.saufdings.Drinklist.prototype.getDrinksList = function() {
  return /** @type{!Array<!proto.saufdings.Drink>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.Drink, 1));
};


/**
 * @param {!Array<!proto.saufdings.Drink>} value
 * @return {!proto.saufdings.Drinklist} returns this
*/
proto.saufdings.Drinklist.prototype.setDrinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saufdings.Drink=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.Drink}
 */
proto.saufdings.Drinklist.prototype.addDrinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saufdings.Drink, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.Drinklist} returns this
 */
proto.saufdings.Drinklist.prototype.clearDrinksList = function() {
  return this.setDrinksList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.DrinkActiviteList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.DrinkActiviteList.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.DrinkActiviteList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.DrinkActiviteList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.DrinkActiviteList.toObject = function(includeInstance, msg) {
  var f, obj = {
drinkingactivitesList: jspb.Message.toObjectList(msg.getDrinkingactivitesList(),
    proto.saufdings.DrinkActivity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.DrinkActiviteList}
 */
proto.saufdings.DrinkActiviteList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.DrinkActiviteList;
  return proto.saufdings.DrinkActiviteList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.DrinkActiviteList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.DrinkActiviteList}
 */
proto.saufdings.DrinkActiviteList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.DrinkActivity;
      reader.readMessage(value,proto.saufdings.DrinkActivity.deserializeBinaryFromReader);
      msg.addDrinkingactivites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.DrinkActiviteList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.DrinkActiviteList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.DrinkActiviteList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.DrinkActiviteList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrinkingactivitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saufdings.DrinkActivity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DrinkActivity drinkingActivites = 1;
 * @return {!Array<!proto.saufdings.DrinkActivity>}
 */
proto.saufdings.DrinkActiviteList.prototype.getDrinkingactivitesList = function() {
  return /** @type{!Array<!proto.saufdings.DrinkActivity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.DrinkActivity, 1));
};


/**
 * @param {!Array<!proto.saufdings.DrinkActivity>} value
 * @return {!proto.saufdings.DrinkActiviteList} returns this
*/
proto.saufdings.DrinkActiviteList.prototype.setDrinkingactivitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saufdings.DrinkActivity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.DrinkActivity}
 */
proto.saufdings.DrinkActiviteList.prototype.addDrinkingactivites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saufdings.DrinkActivity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.DrinkActiviteList} returns this
 */
proto.saufdings.DrinkActiviteList.prototype.clearDrinkingactivitesList = function() {
  return this.setDrinkingactivitesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.EventList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.EventList.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.EventList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.EventList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventList.toObject = function(includeInstance, msg) {
  var f, obj = {
eventsList: jspb.Message.toObjectList(msg.getEventsList(),
    proto.saufdings.Event.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.EventList}
 */
proto.saufdings.EventList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.EventList;
  return proto.saufdings.EventList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.EventList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.EventList}
 */
proto.saufdings.EventList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.Event;
      reader.readMessage(value,proto.saufdings.Event.deserializeBinaryFromReader);
      msg.addEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.EventList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.EventList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.EventList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saufdings.Event.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Event events = 1;
 * @return {!Array<!proto.saufdings.Event>}
 */
proto.saufdings.EventList.prototype.getEventsList = function() {
  return /** @type{!Array<!proto.saufdings.Event>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.Event, 1));
};


/**
 * @param {!Array<!proto.saufdings.Event>} value
 * @return {!proto.saufdings.EventList} returns this
*/
proto.saufdings.EventList.prototype.setEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saufdings.Event=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.Event}
 */
proto.saufdings.EventList.prototype.addEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saufdings.Event, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.EventList} returns this
 */
proto.saufdings.EventList.prototype.clearEventsList = function() {
  return this.setEventsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
eventid: jspb.Message.getFieldWithDefault(msg, 1, 0),
eventname: jspb.Message.getFieldWithDefault(msg, 2, ""),
location: jspb.Message.getFieldWithDefault(msg, 3, ""),
tshappeningstart: (f = msg.getTshappeningstart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
tshappeningend: (f = msg.getTshappeningend()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
owneruserid: jspb.Message.getFieldWithDefault(msg, 6, 0),
isactive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
visibility: jspb.Message.getFieldWithDefault(msg, 8, 0),
requirespassword: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
isparticipant: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.Event}
 */
proto.saufdings.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.Event;
  return proto.saufdings.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.Event}
 */
proto.saufdings.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEventid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTshappeningstart(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTshappeningend(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOwneruserid(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsactive(value);
      break;
    case 8:
      var value = /** @type {!proto.saufdings.EventVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequirespassword(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsparticipant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEventname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTshappeningstart();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTshappeningend();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOwneruserid();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getIsactive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getRequirespassword();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsparticipant();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional int32 eventId = 1;
 * @return {number}
 */
proto.saufdings.Event.prototype.getEventid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setEventid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string eventName = 2;
 * @return {string}
 */
proto.saufdings.Event.prototype.getEventname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setEventname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string location = 3;
 * @return {string}
 */
proto.saufdings.Event.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp tsHappeningStart = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.Event.prototype.getTshappeningstart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.Event} returns this
*/
proto.saufdings.Event.prototype.setTshappeningstart = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.clearTshappeningstart = function() {
  return this.setTshappeningstart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.Event.prototype.hasTshappeningstart = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp tsHappeningEnd = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.Event.prototype.getTshappeningend = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.Event} returns this
*/
proto.saufdings.Event.prototype.setTshappeningend = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.clearTshappeningend = function() {
  return this.setTshappeningend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.Event.prototype.hasTshappeningend = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 ownerUserId = 6;
 * @return {number}
 */
proto.saufdings.Event.prototype.getOwneruserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setOwneruserid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool isActive = 7;
 * @return {boolean}
 */
proto.saufdings.Event.prototype.getIsactive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setIsactive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional EventVisibility visibility = 8;
 * @return {!proto.saufdings.EventVisibility}
 */
proto.saufdings.Event.prototype.getVisibility = function() {
  return /** @type {!proto.saufdings.EventVisibility} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.saufdings.EventVisibility} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional bool requiresPassword = 9;
 * @return {boolean}
 */
proto.saufdings.Event.prototype.getRequirespassword = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setRequirespassword = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool isParticipant = 10;
 * @return {boolean}
 */
proto.saufdings.Event.prototype.getIsparticipant = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.Event} returns this
 */
proto.saufdings.Event.prototype.setIsparticipant = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.ListEventsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.ListEventsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.ListEventsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ListEventsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
includeinactive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.ListEventsRequest}
 */
proto.saufdings.ListEventsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.ListEventsRequest;
  return proto.saufdings.ListEventsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.ListEventsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.ListEventsRequest}
 */
proto.saufdings.ListEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeinactive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.ListEventsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.ListEventsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.ListEventsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ListEventsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getIncludeinactive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.saufdings.ListEventsRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.ListEventsRequest} returns this
*/
proto.saufdings.ListEventsRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.ListEventsRequest} returns this
 */
proto.saufdings.ListEventsRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.ListEventsRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool includeInactive = 2;
 * @return {boolean}
 */
proto.saufdings.ListEventsRequest.prototype.getIncludeinactive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.ListEventsRequest} returns this
 */
proto.saufdings.ListEventsRequest.prototype.setIncludeinactive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.CreateEventRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.CreateEventRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.CreateEventRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.CreateEventRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
eventname: jspb.Message.getFieldWithDefault(msg, 2, ""),
location: jspb.Message.getFieldWithDefault(msg, 3, ""),
visibility: jspb.Message.getFieldWithDefault(msg, 4, 0),
accesspassword: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.CreateEventRequest}
 */
proto.saufdings.CreateEventRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.CreateEventRequest;
  return proto.saufdings.CreateEventRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.CreateEventRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.CreateEventRequest}
 */
proto.saufdings.CreateEventRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 4:
      var value = /** @type {!proto.saufdings.EventVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccesspassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.CreateEventRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.CreateEventRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.CreateEventRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.CreateEventRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getEventname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.saufdings.CreateEventRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.CreateEventRequest} returns this
*/
proto.saufdings.CreateEventRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.CreateEventRequest} returns this
 */
proto.saufdings.CreateEventRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.CreateEventRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string eventName = 2;
 * @return {string}
 */
proto.saufdings.CreateEventRequest.prototype.getEventname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.CreateEventRequest} returns this
 */
proto.saufdings.CreateEventRequest.prototype.setEventname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string location = 3;
 * @return {string}
 */
proto.saufdings.CreateEventRequest.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.CreateEventRequest} returns this
 */
proto.saufdings.CreateEventRequest.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EventVisibility visibility = 4;
 * @return {!proto.saufdings.EventVisibility}
 */
proto.saufdings.CreateEventRequest.prototype.getVisibility = function() {
  return /** @type {!proto.saufdings.EventVisibility} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.saufdings.EventVisibility} value
 * @return {!proto.saufdings.CreateEventRequest} returns this
 */
proto.saufdings.CreateEventRequest.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string accessPassword = 5;
 * @return {string}
 */
proto.saufdings.CreateEventRequest.prototype.getAccesspassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.CreateEventRequest} returns this
 */
proto.saufdings.CreateEventRequest.prototype.setAccesspassword = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.CreateEventRequest} returns this
 */
proto.saufdings.CreateEventRequest.prototype.clearAccesspassword = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.CreateEventRequest.prototype.hasAccesspassword = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.EventMembershipRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.EventMembershipRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.EventMembershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventMembershipRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
eventid: jspb.Message.getFieldWithDefault(msg, 2, 0),
accesspassword: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.EventMembershipRequest}
 */
proto.saufdings.EventMembershipRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.EventMembershipRequest;
  return proto.saufdings.EventMembershipRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.EventMembershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.EventMembershipRequest}
 */
proto.saufdings.EventMembershipRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEventid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccesspassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.EventMembershipRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.EventMembershipRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.EventMembershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventMembershipRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getEventid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAccesspassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.saufdings.EventMembershipRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.EventMembershipRequest} returns this
*/
proto.saufdings.EventMembershipRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.EventMembershipRequest} returns this
 */
proto.saufdings.EventMembershipRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.EventMembershipRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 eventId = 2;
 * @return {number}
 */
proto.saufdings.EventMembershipRequest.prototype.getEventid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EventMembershipRequest} returns this
 */
proto.saufdings.EventMembershipRequest.prototype.setEventid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string accessPassword = 3;
 * @return {string}
 */
proto.saufdings.EventMembershipRequest.prototype.getAccesspassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.EventMembershipRequest} returns this
 */
proto.saufdings.EventMembershipRequest.prototype.setAccesspassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.ActiveEventResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.ActiveEventResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.ActiveEventResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ActiveEventResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
event: (f = msg.getEvent()) && proto.saufdings.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.ActiveEventResponse}
 */
proto.saufdings.ActiveEventResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.ActiveEventResponse;
  return proto.saufdings.ActiveEventResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.ActiveEventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.ActiveEventResponse}
 */
proto.saufdings.ActiveEventResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.Event;
      reader.readMessage(value,proto.saufdings.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.ActiveEventResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.ActiveEventResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.ActiveEventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ActiveEventResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.saufdings.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional Event event = 1;
 * @return {?proto.saufdings.Event}
 */
proto.saufdings.ActiveEventResponse.prototype.getEvent = function() {
  return /** @type{?proto.saufdings.Event} */ (
    jspb.Message.getWrapperField(this, proto.saufdings.Event, 1));
};


/**
 * @param {?proto.saufdings.Event|undefined} value
 * @return {!proto.saufdings.ActiveEventResponse} returns this
*/
proto.saufdings.ActiveEventResponse.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.ActiveEventResponse} returns this
 */
proto.saufdings.ActiveEventResponse.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.ActiveEventResponse.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.EventLeaderboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.EventLeaderboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.EventLeaderboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventLeaderboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
eventid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.EventLeaderboardRequest}
 */
proto.saufdings.EventLeaderboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.EventLeaderboardRequest;
  return proto.saufdings.EventLeaderboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.EventLeaderboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.EventLeaderboardRequest}
 */
proto.saufdings.EventLeaderboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEventid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.EventLeaderboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.EventLeaderboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.EventLeaderboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventLeaderboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getEventid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.saufdings.EventLeaderboardRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.EventLeaderboardRequest} returns this
*/
proto.saufdings.EventLeaderboardRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.EventLeaderboardRequest} returns this
 */
proto.saufdings.EventLeaderboardRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.EventLeaderboardRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 eventId = 2;
 * @return {number}
 */
proto.saufdings.EventLeaderboardRequest.prototype.getEventid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EventLeaderboardRequest} returns this
 */
proto.saufdings.EventLeaderboardRequest.prototype.setEventid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.EventLeaderboardEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.EventLeaderboardEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.EventLeaderboardEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventLeaderboardEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
username: jspb.Message.getFieldWithDefault(msg, 2, ""),
activitycount: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalvolumeml: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
totalalcoholgrams: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.EventLeaderboardEntry}
 */
proto.saufdings.EventLeaderboardEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.EventLeaderboardEntry;
  return proto.saufdings.EventLeaderboardEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.EventLeaderboardEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.EventLeaderboardEntry}
 */
proto.saufdings.EventLeaderboardEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActivitycount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalvolumeml(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalalcoholgrams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.EventLeaderboardEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.EventLeaderboardEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.EventLeaderboardEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventLeaderboardEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActivitycount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalvolumeml();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTotalalcoholgrams();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.saufdings.EventLeaderboardEntry.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EventLeaderboardEntry} returns this
 */
proto.saufdings.EventLeaderboardEntry.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.saufdings.EventLeaderboardEntry.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.EventLeaderboardEntry} returns this
 */
proto.saufdings.EventLeaderboardEntry.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 activityCount = 3;
 * @return {number}
 */
proto.saufdings.EventLeaderboardEntry.prototype.getActivitycount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EventLeaderboardEntry} returns this
 */
proto.saufdings.EventLeaderboardEntry.prototype.setActivitycount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double totalVolumeMl = 4;
 * @return {number}
 */
proto.saufdings.EventLeaderboardEntry.prototype.getTotalvolumeml = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EventLeaderboardEntry} returns this
 */
proto.saufdings.EventLeaderboardEntry.prototype.setTotalvolumeml = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double totalAlcoholGrams = 5;
 * @return {number}
 */
proto.saufdings.EventLeaderboardEntry.prototype.getTotalalcoholgrams = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EventLeaderboardEntry} returns this
 */
proto.saufdings.EventLeaderboardEntry.prototype.setTotalalcoholgrams = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.EventLeaderboardResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.EventLeaderboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.EventLeaderboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.EventLeaderboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventLeaderboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.saufdings.EventLeaderboardEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.EventLeaderboardResponse}
 */
proto.saufdings.EventLeaderboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.EventLeaderboardResponse;
  return proto.saufdings.EventLeaderboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.EventLeaderboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.EventLeaderboardResponse}
 */
proto.saufdings.EventLeaderboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.EventLeaderboardEntry;
      reader.readMessage(value,proto.saufdings.EventLeaderboardEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.EventLeaderboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.EventLeaderboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.EventLeaderboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EventLeaderboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saufdings.EventLeaderboardEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EventLeaderboardEntry entries = 1;
 * @return {!Array<!proto.saufdings.EventLeaderboardEntry>}
 */
proto.saufdings.EventLeaderboardResponse.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.saufdings.EventLeaderboardEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.EventLeaderboardEntry, 1));
};


/**
 * @param {!Array<!proto.saufdings.EventLeaderboardEntry>} value
 * @return {!proto.saufdings.EventLeaderboardResponse} returns this
*/
proto.saufdings.EventLeaderboardResponse.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saufdings.EventLeaderboardEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.EventLeaderboardEntry}
 */
proto.saufdings.EventLeaderboardResponse.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saufdings.EventLeaderboardEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.EventLeaderboardResponse} returns this
 */
proto.saufdings.EventLeaderboardResponse.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.UpdateEventAccessRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.UpdateEventAccessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.UpdateEventAccessRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
eventid: jspb.Message.getFieldWithDefault(msg, 2, 0),
visibility: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
accesspassword: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.UpdateEventAccessRequest}
 */
proto.saufdings.UpdateEventAccessRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.UpdateEventAccessRequest;
  return proto.saufdings.UpdateEventAccessRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.UpdateEventAccessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.UpdateEventAccessRequest}
 */
proto.saufdings.UpdateEventAccessRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEventid(value);
      break;
    case 3:
      var value = /** @type {!proto.saufdings.EventVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccesspassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.UpdateEventAccessRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.UpdateEventAccessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.UpdateEventAccessRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getEventid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {!proto.saufdings.EventVisibility} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.UpdateEventAccessRequest} returns this
*/
proto.saufdings.UpdateEventAccessRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.UpdateEventAccessRequest} returns this
 */
proto.saufdings.UpdateEventAccessRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 eventId = 2;
 * @return {number}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.getEventid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.UpdateEventAccessRequest} returns this
 */
proto.saufdings.UpdateEventAccessRequest.prototype.setEventid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional EventVisibility visibility = 3;
 * @return {!proto.saufdings.EventVisibility}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.getVisibility = function() {
  return /** @type {!proto.saufdings.EventVisibility} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.saufdings.EventVisibility} value
 * @return {!proto.saufdings.UpdateEventAccessRequest} returns this
 */
proto.saufdings.UpdateEventAccessRequest.prototype.setVisibility = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateEventAccessRequest} returns this
 */
proto.saufdings.UpdateEventAccessRequest.prototype.clearVisibility = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.hasVisibility = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string accessPassword = 4;
 * @return {string}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.getAccesspassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.UpdateEventAccessRequest} returns this
 */
proto.saufdings.UpdateEventAccessRequest.prototype.setAccesspassword = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateEventAccessRequest} returns this
 */
proto.saufdings.UpdateEventAccessRequest.prototype.clearAccesspassword = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateEventAccessRequest.prototype.hasAccesspassword = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.Drink.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.Drink.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.Drink} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Drink.toObject = function(includeInstance, msg) {
  var f, obj = {
drinkname: jspb.Message.getFieldWithDefault(msg, 1, ""),
promille: jspb.Message.getFieldWithDefault(msg, 2, 0),
drinkid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.Drink}
 */
proto.saufdings.Drink.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.Drink;
  return proto.saufdings.Drink.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.Drink} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.Drink}
 */
proto.saufdings.Drink.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDrinkname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPromille(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDrinkid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.Drink.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.Drink.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.Drink} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Drink.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrinkname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPromille();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDrinkid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string drinkname = 1;
 * @return {string}
 */
proto.saufdings.Drink.prototype.getDrinkname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.Drink} returns this
 */
proto.saufdings.Drink.prototype.setDrinkname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 promille = 2;
 * @return {number}
 */
proto.saufdings.Drink.prototype.getPromille = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Drink} returns this
 */
proto.saufdings.Drink.prototype.setPromille = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 drinkId = 3;
 * @return {number}
 */
proto.saufdings.Drink.prototype.getDrinkid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Drink} returns this
 */
proto.saufdings.Drink.prototype.setDrinkid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.DrinkActivity.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.DrinkActivity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.DrinkActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.DrinkActivity.toObject = function(includeInstance, msg) {
  var f, obj = {
drink: (f = msg.getDrink()) && proto.saufdings.Drink.toObject(includeInstance, f),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
tsinsert: (f = msg.getTsinsert()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
eventid: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
activityid: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
tsstart: (f = msg.getTsstart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.DrinkActivity}
 */
proto.saufdings.DrinkActivity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.DrinkActivity;
  return proto.saufdings.DrinkActivity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.DrinkActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.DrinkActivity}
 */
proto.saufdings.DrinkActivity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.Drink;
      reader.readMessage(value,proto.saufdings.Drink.deserializeBinaryFromReader);
      msg.setDrink(value);
      break;
    case 2:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsinsert(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEventid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActivityid(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsstart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.DrinkActivity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.DrinkActivity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.DrinkActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.DrinkActivity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDrink();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.saufdings.Drink.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTsinsert();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTsstart();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Drink drink = 1;
 * @return {?proto.saufdings.Drink}
 */
proto.saufdings.DrinkActivity.prototype.getDrink = function() {
  return /** @type{?proto.saufdings.Drink} */ (
    jspb.Message.getWrapperField(this, proto.saufdings.Drink, 1));
};


/**
 * @param {?proto.saufdings.Drink|undefined} value
 * @return {!proto.saufdings.DrinkActivity} returns this
*/
proto.saufdings.DrinkActivity.prototype.setDrink = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.clearDrink = function() {
  return this.setDrink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.DrinkActivity.prototype.hasDrink = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional users.UserData user = 2;
 * @return {?proto.users.UserData}
 */
proto.saufdings.DrinkActivity.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 2));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.DrinkActivity} returns this
*/
proto.saufdings.DrinkActivity.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.DrinkActivity.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 amount = 3;
 * @return {number}
 */
proto.saufdings.DrinkActivity.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp tsInsert = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.DrinkActivity.prototype.getTsinsert = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.DrinkActivity} returns this
*/
proto.saufdings.DrinkActivity.prototype.setTsinsert = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.clearTsinsert = function() {
  return this.setTsinsert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.DrinkActivity.prototype.hasTsinsert = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 eventId = 5;
 * @return {number}
 */
proto.saufdings.DrinkActivity.prototype.getEventid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.setEventid = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.clearEventid = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.DrinkActivity.prototype.hasEventid = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 activityId = 6;
 * @return {number}
 */
proto.saufdings.DrinkActivity.prototype.getActivityid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.setActivityid = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.clearActivityid = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.DrinkActivity.prototype.hasActivityid = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp tsStart = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.DrinkActivity.prototype.getTsstart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.DrinkActivity} returns this
*/
proto.saufdings.DrinkActivity.prototype.setTsstart = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.DrinkActivity} returns this
 */
proto.saufdings.DrinkActivity.prototype.clearTsstart = function() {
  return this.setTsstart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.DrinkActivity.prototype.hasTsstart = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * @enum {number}
 */
proto.saufdings.EventVisibility = {
  EVENT_VISIBILITY_PUBLIC: 0,
  EVENT_VISIBILITY_FRIENDS: 1,
  EVENT_VISIBILITY_PASSWORD: 2,
  EVENT_VISIBILITY_PRIVATE: 3
};

goog.object.extend(exports, proto.saufdings);
